/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of StockCheckScheduleClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfList_1OfStockCheckScheduleDetail,
  SuccessResponse_1OfStockCheckScheduleDetails,
  StockCheckScheduleDetail,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockSchedules = [
  {
    id: 1,
    name: 'Weekly Full Count',
    storeNumber: 'STORE001',
    stockCheckType: 1,
    frequency: 'Weekly',
    dayOfWeek: 'Monday',
    time: '08:00',
    isActive: true,
    nextRun: '2025-12-16',
  },
  {
    id: 2,
    name: 'Daily Dairy Check',
    storeNumber: 'STORE001',
    stockCheckType: 2,
    frequency: 'Daily',
    dayOfWeek: '',
    time: '06:00',
    isActive: true,
    nextRun: '2025-12-13',
  },
];

/* ---- Mocked Client Implementation ---- */

import { IStockCheckScheduleClient } from '../../interfaces';
export class StockCheckScheduleClientMocked implements IStockCheckScheduleClient {
  constructor(baseUrl?: string) {}

  async stockcheckscheduleGET(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfStockCheckScheduleDetail> {
    await delay();
    const schedules = mockSchedules.filter((s) => s.storeNumber === storeNumber);
    return successResponse(schedules) as SuccessResponse_1OfList_1OfStockCheckScheduleDetail;
  }

  async stockcheckschedulePOST(storeNumber: string, body?: StockCheckScheduleDetail, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body) {
      mockSchedules.push({
        id: mockSchedules.length + 1,
        name: body.name || 'New Schedule',
        storeNumber,
        stockCheckType: body.stockCheckType || 1,
        frequency: 'Weekly',
        dayOfWeek: '',
        time: '08:00',
        isActive: body.isActive || true,
        nextRun: '',
      });
    }
  }

  async scheduleGET(storeNumber: string, id: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfStockCheckScheduleDetails> {
    await delay();
    const schedule = mockSchedules.find((s) => s.id === id && s.storeNumber === storeNumber) || mockSchedules[0];
    return successResponse({
      stockCheckSchedule: schedule,
      stores: [],
    }) as SuccessResponse_1OfStockCheckScheduleDetails;
  }

  async scheduleDELETE(storeNumber: string, id: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockSchedules.findIndex((s) => s.id === id && s.storeNumber === storeNumber);
    if (index > -1) {
      mockSchedules.splice(index, 1);
    }
  }

  async schedulePUT(storeNumber: string, id: number, body?: StockCheckScheduleDetail, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const schedule = mockSchedules.find((s) => s.id === id && s.storeNumber === storeNumber);
    if (schedule && body) {
      schedule.name = body.name || schedule.name;
    }
  }

  // ====== Auto-generated stub methods ======








    async generatestockchecks(storeNumber: string, scheduleId: number, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method generatestockchecks not implemented in mocked client');
    }

}
